import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'

export interface TimeBudgetEmployeeEntry {
  employeeTanssId: string
  employeeName: string | null
  totalMinutes: number
  budgetMinutes: number
  usedPercent: number
  isOverBudget: boolean
  isWarning: boolean
}

export interface TimeBudgetStatus {
  contractId: string
  year: number
  month: number
  budgetMinutesPerUser: number | null
  overtageHourlyRateCents: number | null
  userCount: number
  totalBudgetMinutes: number
  totalActualMinutes: number
  totalUsedPercent: number
  isOverBudget: boolean
  isWarning: boolean
  overageMinutes: number
  overageSurchargeCents: number
  employees: TimeBudgetEmployeeEntry[]
}

export function useTimeBudgetStatus(contractId: string, year: number, month: number) {
  return useQuery<TimeBudgetStatus>({
    queryKey: ['time-budget', contractId, year, month],
    queryFn: async () => {
      const { data } = await axios.get(`/api/contracts/${contractId}/time-budget`, {
        params: { year, month },
      })
      return data
    },
    enabled: !!contractId,
  })
}

export function useImportTimeBudget(contractId: string) {
  const queryClient = useQueryClient()
  return useMutation<{ upserted: number; status: TimeBudgetStatus }, Error, { year: number; month: number }>({
    mutationFn: async ({ year, month }) => {
      const { data } = await axios.post(`/api/contracts/${contractId}/time-budget/import`, { year, month })
      return data
    },
    onSuccess: (data, { year, month }) => {
      queryClient.setQueryData(['time-budget', contractId, year, month], data.status)
    },
  })
}
